import { useEffect, useState } from 'react';
import api from './api';
import { useSlotImage } from './useSlotImage';

// Mixkit "Castle and beautiful garden" (#4074) — Mixkit Stock Video Free License, hosted in the site's storage.
export const DEFAULT_VIDEO = '/api/files/jbmh-events/opening/mixkit-castle-and-beautiful-garden-4074-720.mp4';
export const FALLBACK_POSTER = 'https://images.unsplash.com/photo-1785591153754-feaa934af5e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920';

export const OPENING_DEFAULTS = {
  videoEnabled: true,
  videoUrl: DEFAULT_VIDEO,
  posterUrl: '',
  sloganTop: '',
  sloganBottom: '',
  scrollLabel: 'Découvrir',
  focusDesktop: { x: 50, y: 50 },
  focusMobile: { x: 80, y: 50 },
  shade: 30,
};

export const withDefaults = (cfg) => ({ ...OPENING_DEFAULTS, ...(cfg || {}) });

// Published config for visitors; the admin draft when `preview` is on.
export const useOpening = (preview) => {
  const [cfg, setCfg] = useState(null);
  const [isDraft, setIsDraft] = useState(false);
  const [slogan, setSlogan] = useState({ top: 'L’art du détail,', bottom: 'la signature de l’élégance.' });
  const panorama = useSlotImage('hero-panorama', FALLBACK_POSTER);
  useEffect(() => {
    const req = preview ? api.get('/admin/opening').then(({ data }) => data.draft) : api.get('/opening').then(({ data }) => data);
    req.then((d) => { setCfg(withDefaults(d)); setIsDraft(preview); }).catch(() => setCfg(withDefaults({})));
    api.get('/site-settings').then(({ data }) => setSlogan((p) => ({
      top: data.hero_slogan_top || p.top,
      bottom: data.hero_slogan_bottom ?? p.bottom,
    }))).catch(() => {});
  }, [preview]);
  if (!cfg) return null;
  const fix = (s) => (s || '').replace(/'/g, '’');
  return {
    ...cfg,
    isDraft,
    posterUrl: cfg.posterUrl || panorama,
    sloganTop: fix(cfg.sloganTop || slogan.top),
    sloganBottom: fix(cfg.sloganTop ? cfg.sloganBottom : slogan.bottom),
  };
};
